import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { EQueryStageReadModel } from '../models/e-query-stage';
import { distinctUntilChanged, map, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { routeParams } from '../../../shared/route-helpers';
import { ActivatedRoute } from '@angular/router';
import { EQueryStageStorage } from './e-query-stage-storage';

@Component({
    selector: 'prefilled-e-query-create-form',
    template: require('./prefilled-e-query-create-form.component.html'),
    styles: [require('./prefilled-e-query-create-form.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrefilledEQueryCreateFormComponent {
    public readonly prefilledData$: Observable<EQueryStageReadModel>;

    constructor(readonly route: ActivatedRoute, eQueryStageStorage: EQueryStageStorage) {
        const eQueryStageId$ = route.params.pipe(
            map(p => p[routeParams.eQueryStageId] as number),
            distinctUntilChanged(),
            publishReplay(1),
            refCount()
        );

        this.prefilledData$ = eQueryStageId$.pipe(
            switchMap((id => eQueryStageStorage.getEQueryStage(id))),
            publishReplay(1),
            refCount());
    }
}
